import * as XLSX from "xlsx";
import {
  cleanModules,
  cleanTargets,
  cleanQuestions,
  cleanCourse,
} from "./courseCleaners";
import { Course, Module, Question, Target } from "./courseBuilderInterfaces";

export const buildCourseRequest = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: "array" });

  const missingSheets: string[] = [];

  const courseSheet = workbook.Sheets["Course"];
  if (!courseSheet) missingSheets.push("Course");

  const modulesSheet = workbook.Sheets["Modules"];
  if (!modulesSheet) missingSheets.push("Modules");

  const targetsSheet =
    workbook.Sheets["Targets"] ??
    workbook.Sheets["Submodules"] ??
    workbook.Sheets["Lessons"];
  if (!targetsSheet) missingSheets.push("Targets or Submodules");

  const questionsSheet = workbook.Sheets["Learning Maps"] ?? workbook.Sheets["Questions"];
  if (!questionsSheet) missingSheets.push("Questions or Learning Maps");

  if (missingSheets.length > 0) {
    throw new Error(`Missing sheet(s): ${missingSheets.join(", ")}`);
  }

  const courseJSON = cleanCourse(XLSX.utils.sheet_to_json(courseSheet) as Course[]);

  const modulesJSON = cleanModules(XLSX.utils.sheet_to_json(modulesSheet) as Module[]);

  const targetsJSON = cleanTargets(XLSX.utils.sheet_to_json(targetsSheet) as Target[]);

  const questionsJSON = cleanQuestions(
    XLSX.utils.sheet_to_json(questionsSheet) as Question[]
  );

  return {
    course: courseJSON,
    modules: modulesJSON,
    targets: targetsJSON,
    questions: questionsJSON,
  };
};
